import React from "react";
import { useLang } from "../i18n/LanguageContext";
import { IMAGES } from "../lib/site";

const Footer = () => {
  const { t } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#070707] border-t border-white/5 py-14"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Marquee */}
        <div className="overflow-hidden mb-12 border-y border-white/5 py-6">
          <div className="marquee-track flex gap-12 whitespace-nowrap">
            {[...Array(2)].map((_, k) => (
              <div key={k} className="flex gap-12">
                {["Fresh cuts", "Real skill", "No compromise", "Precision fades", "Built in Ii", "Bandido products"].map(
                  (w, i) => (
                    <span
                      key={i}
                      className="font-display uppercase text-4xl md:text-5xl tracking-tight text-white/5 hover:text-gold transition-colors"
                    >
                      {w} <span className="text-gold/40">✦</span>
                    </span>
                  )
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-10 items-start">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src={IMAGES.logo}
                alt="TTcuts Barbershop"
                className="h-12 w-12 rounded-full object-cover"
              />
              <span className="font-display text-xl uppercase">
                TT<span className="text-gold">cuts</span>
              </span>
            </div>
            <p className="text-white/50 text-sm max-w-xs">{t.footer.tagline}</p>
          </div>

          <div className="md:text-center">
            <div className="label-eyebrow text-white/40 mb-3">Find us</div>
            <p className="text-white/70 text-sm">Kivimaantie 19, Ii Yliranta</p>
            <p className="text-white/70 text-sm">0401664749</p>
          </div>

          <div className="md:text-right">
            <div className="label-eyebrow text-white/40 mb-3">Social</div>
            <p className="text-white/70 text-sm">@ttcuts · IG</p>
            <p className="text-white/70 text-sm">@ttcutsbarbershop · TikTok</p>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/5 flex flex-col md:flex-row md:items-center justify-between gap-3 text-xs text-white/40">
          <span>© {year} TTcuts Barbershop. {t.footer.rights}</span>
          <span className="label-eyebrow">Built with passion · Ii, Finland</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
